import React from "react"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import ScrollToTop from "../components/common/ScrollToTop"
import Footer from "../components/common/footer/Footer"
import About from "../components/about/About"
import Branches from "../components/branches/Branches"
import Contact from "../components/contact/Contact"
import Properties from "../components/properties/Properties"
import Property from "../components/properties/Property"
import Home from "../pages/Home"
import Kiralik from "../pages/Kiralik/Kiralik"
import Satilik from "../pages/Satilik/Satilik"
import House from "../pages/House/House"
import Land from "../pages/Land/Land"
import Workplace from "../pages/WorkPlace/Workplace"
import Turistik from "../pages/Touristy/Touristy"
import NavbarYedek from "../components/Header/Headeryedek"
import Dropdown from "../components/Header/Dropdown"
import { useDispatch } from "react-redux"
import { closeDropdown } from "../redux/slice/uiSlice";

const Pages = () => {
  

  const dispatch = useDispatch();

  const handleCloseDropdown = () => {
    dispatch(closeDropdown());
  };

  return (
    <>
     
      <Router>
      <ScrollToTop />
      <NavbarYedek />
        <Dropdown />
        <div
        className=" min-h-screen"
        onClick={handleCloseDropdown}
        onMouseOver={() => dispatch(closeDropdown())}
        >
      
        <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path='/subelerimiz' component={Branches} />
          <Route exact path='/subeler' component={Branches} />
          <Route exact path='/points' component={Branches} />
          <Route exact path='/about' component={About} />
          <Route exact path='/adverts' component={Properties} />
          <Route exact path='/rent' component={Kiralik} />
          <Route exact path='/sale' component={Satilik} />
          <Route exact path='/house' component={House} />
          <Route exact path='/land' component={Land} />
          <Route exact path='/workplace' component={Workplace} />
          <Route exact path='/touristy' component={Turistik} />
          <Route path='/advert/:id' component={Property} />
          <Route exact path='/contact' component={Contact} />
        </Switch>
        
        <Footer />
        </div>
      </Router>
    
     
    </>
  )
}

export default Pages
